import { useIntl } from "react-intl";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import PreLoginContainer from "../../common/preLoginContainer";
import Link from "../../common/link";
import { Field } from "react-final-form";
import { TextInput, Checkbox } from "../../common/fields";
import Form from "../../common/form";
import * as Validations from "../../common/form/validator";
import { RouteConstants } from "../../../constants";
import {
  resetState,
  sendResetPasswordInstructionsRequest,
} from "../../../store/slices/authSlice";
import { useEffect, useState } from "react";

const ForgotPassword = ({
  action,
  error,
  requesting,
  resetState,
  sendResetPasswordInstructionsRequest,
}) => {
  const intl = useIntl();

  const [isInstructionsSent, setIsInstructionsSent] = useState(false);

  useEffect(() => {
    resetState();
  }, [resetState]);

  useEffect(() => {
    if (action === "forgot-password" && !requesting && !error) {
      setIsInstructionsSent(true);
    }
  }, [action, error, requesting]);

  return (
    <PreLoginContainer>
      <div className="title text-center">
        {intl.formatMessage({ id: "forgot_password" })}
      </div>
      {(!isInstructionsSent && (
        <>
          <div className="tag-line text-muted">
            {intl.formatMessage({ id: "reset_link_message" })}
          </div>
          <Form
            initialValues={{
              username: Cookies.get("username") || "",
            }}
            fullWidthButtons
            requesting={action === "forgot-password" && requesting}
            submitBtn={{
              label: intl.formatMessage({ id: "send_reset_link" }),
              icon: "pi-arrow-right",
              onClick: (values) => {
                if (values.rememberMe) {
                  Cookies.set("username", values.username, {
                    expires: 30,
                    secure: true,
                    sameSite: "Strict",
                  });
                }
                sendResetPasswordInstructionsRequest(values);
              },
            }}
          >
            <div className="flex flex-column gap-2 mt-4">
              <Field
                name="username"
                component={TextInput}
                icon="pi-user"
                placeholder={intl.formatMessage({ id: "username" })}
                required
                validate={Validations.composeValidators(Validations.required)}
              />
              <div className="flex align-items-center mt-2">
                <Field
                  name="rememberMe"
                  component={Checkbox}
                  type="checkbox"
                  label={intl.formatMessage({ id: "remember_me" })}
                />
              </div>
            </div>
          </Form>
        </>
      )) || (
        <div className="tag-line text-muted">
          {intl.formatMessage({ id: "reset_link_success_message" })}
        </div>
      )}

      <div className="text-center mt-1">
        <Link to={RouteConstants.APP_ROUTE_LOGIN}>
          {intl.formatMessage({ id: "back_to_login" })}
        </Link>
      </div>
    </PreLoginContainer>
  );
};

const mapStateToProps = (state) => ({
  requesting: state.auth.requesting,
  error: state.auth.error,
  action: state.auth.action,
});

const mapDispatchToProps = (dispatch) => ({
  sendResetPasswordInstructionsRequest: (data) =>
    dispatch(sendResetPasswordInstructionsRequest(data)),
  resetState: () => dispatch(resetState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
